import React from "react";
import styled from "styled-components";
import SearchIcon from "@material-ui/icons/Search";
import { Faq, Footer, AppDownload, Header } from "../components/index";

const FaqPage = () => {
  return (
    <>
      <Header />
      <Wrapper>
        <section className="section">
          <div className="section-center">
            <div className="content-wrapper">
              <h1 className="heading-text">Frequently Asked Questions</h1>
              <p>
                Do you have questions about our delivery platform and how
                everything works? Check through our frequently asked questions
                and get the answers you need.
              </p>
            </div>
          </div>
        </section>
        <div className="svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
        <Faq />

        <AppDownload />
        {/* Footer Section  */}
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  .section {
    background: #e5edfc;
    width: 100%;
    height: 583.55px;
  }
  .content-wrapper {
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 66px;
      line-height: 76px;
      text-align: center;
      color: #6300ff;
      width: 682px;
      height: 152px;
    }

    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 30px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #777e91;
      width: 639px;
      height: 64px;
      margin-top: 25px;
    }
  }
  .download_app_section {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    /* position: relative; */
    justify-content: space-between;
  }
  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 119px;
  }

  .faq_answer_text {
    font-size: 20px;
    font-weight: 600;
    background: #e5edfc;
    padding-left: 20px;
  }
  @media (max-width: 768px) {
    .svg {
      margin: -1px !important;
    }

    .input_wrapper {
      position: relative;
      width: 100%;
      padding: 0 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .buPdIn .faq_wrapper {
      width: 100%;
      margin: auto;
      padding: 50px 30px 0px 30px;
    }
    .buPdIn .faq_answer {
      font-size: 20px;
      font-weight: 600;
      padding: 22px 0 22px 20px;
      background: #e5edfc;
    }
    .faq_answer_text {
      font-size: 20px;
      font-weight: 600;
      background: #e5edfc;
      padding-left: 0px;
    }
    .downbload_image {
      display: none;
    }
    .nBKTt .download_app_wrapper {
      /* display: -webkit-box; */
      /* display: -webkit-flex; */
      display: -ms-flexbox;
      display: flex;
      position: relative;
      flex-direction: row;
      justify-content: center;
      width: 100%;
    }
    .nBKTt .download_text {
      text-align: left !important;
      position: absolute;
      width: 50%;
      right: 0;
      height: 92px;
      top: 182px;
    }

    .content-wrapper {
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 31px;
        line-height: 56px;
        text-align: center;
        color: #6300ff;
        width: 100%;
        height: 152px;
      }

      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 30px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #777e91;
        width: 100%;
        height: 64px;
        margin-top: -10px;
      }
    }
  }
`;

export default FaqPage;
